export enum MemberType {
  Primary = 'Primary',
  Spouse = 'Spouse',
  Dependent = 'Dependent',
}
